<template>
  <div>
    <div slot="header" style="display: grid; grid-template-columns: 1fr auto;">
      <span>
        <!--        v-if="exportRole"-->
        <hl-button @click="handleExport" :loading="exportLoading" v-if="exportRole">
          {{ $t('Common.exportData') }}
        </hl-button>
      </span>
      <CommonForm @search="formSearch" :form-json="formjson" />
    </div>
    <!--    <div class="header">
      <div class="search">
        <Button></Button>
        <el-select
          v-model="timeType"
          :placeholder="$t('Common.tipsSelect1')"
          size="small"
          @change="handleTimeType"
        >
          <el-option :label="`1 ${$t('Device.hour')}`" :value="1"> </el-option>
          <el-option :label="`1 ${$t('Device.day')}`" :value="2"> </el-option>
          <el-option :label="`7 ${$t('Device.day')}`" :value="3"> </el-option>
          <el-option :label="$t('Device.custom')" :value="4"> </el-option>
        </el-select>
      </div>
    </div>-->
    <div class="chart" v-loading="chartLoading">
      <div id="chart" v-if="xaxisData.length > 0"></div>
      <Empty v-else style="margin:auto;" />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import formjson from './Model/Formjson.Index'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
import dayjs from 'dayjs'
import Empty from '@/components/Empty'
import { downloadFile } from '@/utils/download'

export default {
  name: 'index',
  mixins: [getRoleFromPath, formTableMixin],
  components: {
    Empty
  },
  data() {
    return {
      formjson,
      queryApi: '',
      chartLoading: false,
      xaxisData: [],
      yaxisData: [],
      exportLoading: false,
      date: []
    }
  },
  created() {},
  props: {
    roleList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    exportRole() {
      let role = getRoleByOperationCode(this.roleList, 'export')
      return role ? role.isPermission == 'Y' : false
    }
  },
  methods: {
    handleExport() {
      this.exportLoading = true
      const params = {
        deviceId: this.$route.query.id,
        identifier: 'cabinetTemp',
        startTime: this.date[0],
        endTime: this.date[1]
      }
      return this.$ajax
        .download(this.$api.iceDevice.iceDevice_temperature_export, params)
        .then((res) => {
          downloadFile(res)
        })
        .catch(() => {})
        .finally(() => {
          this.exportLoading = false
        })
    },
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      console.log(data)
      this.init(data)
      // return this.search(data, pageObj, this.queryApi)
    },
    init(data) {
      // this.queryChartData(data).then(() => {
      //   this.initChart()
      // })

      this.queryChartData(data).then(() => {
        this.initChart()
      })
      // this.$nextTick(() => {
      //
      // })
    },
    initChart() {
      const chartDom = document.getElementById('chart')
      if (!chartDom) return
      const myChart = echarts.init(chartDom)
      const option = {
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#666666'
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#999'
            }
          },
          data: this.xaxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#666666',
            formatter: '{value} ℃'
          }
        },
        grid: {
          top: 32,
          bottom: 24,
          left: 68,
          right: 24
        },
        tooltip: {
          trigger: 'axis',

          // formatter: function (params) {
          //   return params[0].data+'℃'
          // },
          formatter: (params) => {
            console.log('params', params)
            // 获取xAxis data中的数据
            let dataStr = `<div><p style='font-weight:bold;margin:0 8px 15px;'>${params[0].axisValue}</p></div>`
            params.forEach((item) => {
              dataStr += `<div>
          <div style='margin: 0 4px;'>
            <span style='display:inline-block;margin-right:5px;width:10px;height:10px;background-color:#2046c7;border-radius:5px'></span>
            <span style='float:right;color:#000000;margin-left:20px;'>${item.data}℃</span>
          </div>
        </div>`
            })
            return dataStr
          }
        },
        series: [
          {
            data: this.yaxisData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: {
              color: '#2046c7',
              width: 3,
              shadowColor: 'rgba(101,110,125,0.15)',
              shadowBlur: 8,
              shadowOffsetX: 0,
              shadowOffsetY: 10
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },

    queryChartData(data) {
      let endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      let startTime = ''
      if (data['days'] === 1) {
        // 1小时
        startTime = dayjs()
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      } else if (data['days'] === 7) {
        // 1天
        startTime = dayjs()
          .subtract(7, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      } else if (data['days'] === 30) {
        // 30天
        startTime = dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      }
      this.date = [startTime, endTime]
      this.chartLoading = true
      const params = {
        deviceId: this.$route.query.id,
        identifier: 'cabinetTemp',
        startTime: startTime,
        endTime: endTime
      }
      return this.$ajax
        .get(this.$api.iceDevice.iceDevice_shadow_history_chart, params)
        .then((res) => {
          this.chartLoading = false
          if (res.data) {
            this.xaxisData = res.data.map((item) => this.formatXaxis(item.createTime))
            this.yaxisData = res.data.map((item) => item.something)
          }
        })
        .catch(() => {})
        .finally(() => {})
    },
    formatXaxis(value) {
      const startTime = dayjs(this.date[0]).valueOf()
      const endTime = dayjs(this.date[1]).valueOf()
      if (endTime - startTime <= 86400000) {
        return dayjs(value).format('HH:mm')
      } else {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
}
#chart {
  height: 300px;
  width: 100%;
}
</style>
